import {connect} from 'pwa-helpers';
import {LitElement, html, css, svg} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

import store from '../store';
import {getValueOfFeature} from '../util/values';

@customElement('svg-icon')
export class SvgIcon extends LitElement {

	static styles = css`
	  .svg {
		display: block;
		box-sizing: border-box;
		width: 100%;
		height: auto;
		position: relative;
	  }

	  .svg > canvas {
		visibility: hidden;
		display: block;
		width: inherit;
		height: inherit;
	  }

	  .svg > svg {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		fill: currentColor;
	  }

	  svg,
	  svg use {
		box-sizing: content-box;
	  }
	`;

	@property({type: String})
	icon = '';

	@property({type: String})
	width = '';

	@property({type: String})
	height = '';


	render() {
		const s = svg`
			<svg focusable="false" viewBox="0 0 ${this.width} ${this.height}">
				<use xlink:href="#${this.icon}"></use>
			</svg>`;

		return html`
			<span class="svg">
				<canvas width="${this.width}" height="${this.height}"></canvas>
				${s}
			</span>
		`;
	}
}
